import { ScanTranslations } from './zh';

export const scanEn: ScanTranslations = {
  // Page Titles
  title: 'Inventory Scanning',
  subtitle: 'Scan part QR codes for check-in/check-out operations',
  checkInTitle: 'Scan Check In',
  checkOutTitle: 'Scan Check Out',
  
  // Scan Area
  scanArea: 'Scan Area',
  cameraMode: 'Camera Scan',
  manualMode: 'Manual Input',
  enterQRCode: 'Enter QR Code',
  scanButton: 'Scan',
  scanning: 'Scanning...',
  cameraPlaceholder: 'Camera scanning feature under development',
  cameraHint: 'Please use manual input mode for current version',
  
  // Actions
  startScanning: 'Start Scanning',
  stopScanning: 'Stop Scanning',
  scanCodePrompt: 'Please scan barcode',
  confirmOperation: 'Confirm Operation',
  
  // Information Display
  partInfo: 'Part Information',
  operationDetails: 'Operation Details',
  noPartScanned: 'No part scanned yet',
  scanOrEnterCode: 'Please scan or enter part QR code',
  
  // Messages
  emptyCode: 'Please enter QR code',
  scanSuccess: 'Scan successful',
  scanFailed: 'Scan failed, part not found',
  checkPermissions: 'Please check camera permissions',
};

